<div [id]="id" tabindex="-1"
    class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
    <div class="relative w-full max-w-lg max-h-full rounded-lg mx-auto" (click)="$event.stopPropagation()">
        <div class="relative bg-primary-purple-light-2 rounded-lg shadow">
            <div class="p-6 pt-5">
                <h3 class="text-[22px] text-center font-bold mb-2 dark:text-gray-400">
                    {{ literalService.get('bookings.restrictions.title', true) }}
                </h3>
                <p class="text-base text-center font-normal mb-5 dark:text-gray-400">
                    {{ literalService.get('bookings.restrictions.subtitle', false) }}
                </p>

                <div class="max-h-80 overflow-y-auto">
                    <div *ngFor="let warning of warnings; let i = index" class="not-first:mt-3">
                        <div class="flex items-start gap-3 rounded-lg bg-white px-4 py-3 text-base font-semibold">
                            <svg aria-hidden="true" class="mt-0.5 h-5 w-5 shrink-0 text-secondary-orange-02" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path></svg>
                            <span>{{ reasonLabel(warning.reason) }}</span>
                        </div>

                        <div *ngFor="let reservation of affectedByWarning[i]" class="mt-2 px-1 flex items-center justify-between gap-3">
                            <div class="min-w-0">
                                <div class="font-semibold text-sm">{{ reservation.userName || '-' }}</div>
                                <div *ngFor="let affected of reservation.stops" class="flex flex-wrap items-baseline gap-1 text-sm pl-2">
                                    <span class="text-neutrals-grey-04">{{ affected.stopName }}:</span>
                                    <span *ngIf="affected.communicatedDateTime">{{ timeOf(affected.communicatedDateTime) }} →</span>
                                    <span class="font-semibold">{{ timeOf(affected.proposedDateTime) }}</span>
                                    <span *ngIf="signedMinutes(affected)">({{ signedMinutes(affected) }} {{ literalService.get('bookings.restrictions.minutes', false) }})</span>
                                </div>
                            </div>
                            <a [href]="bookingUrl(reservation.reservationId)" target="_blank" rel="noopener" class="shrink-0 flex items-center cursor-pointer" (click)="utilsService.openInNewTab($event, bookingUrl(reservation.reservationId))" [tooltip]="literalService.get('trips.modal.bookings.button', true)" [position]="TooltipPosition.ABOVE">
                                <img [src]="images.externalLink" alt="booking" class="h-6 w-6" />
                            </a>
                        </div>
                    </div>
                </div>

                <button type="button" (click)="onConfirm()"
                    class="primary gap-4 p-2 border-2 font-semibold h-12 w-full uppercase cursor-pointer mt-6">
                    {{ literalService.get('bookings.restrictions.confirm', true) }}
                </button>
                <button type="button" (click)="onClose()"
                    class="secondary bg-white gap-4 p-2 border-2 font-semibold h-12 w-full uppercase cursor-pointer mt-3">
                    {{ literalService.get('cancel', true) }}
                </button>
            </div>
        </div>
    </div>
</div>
